module.exports = __webpack_public_path__ + "img/4a61cde446288bdf9e4db237f9f55a2b.png";